// Lazy-loaded page components for App.tsx's route table — split out so the
// route table itself stays under the house 600-line file limit.
import { lazy } from 'react'

export const AdminBusinessDetailPage = lazy(() =>
  import('@/pages/AdminBusinessDetailPage').then((m) => ({ default: m.AdminBusinessDetailPage }))
)
export const AdminDashboardPage = lazy(() =>
  import('@/pages/AdminDashboardPage').then((m) => ({ default: m.AdminDashboardPage }))
)
export const AdsPerformancePage = lazy(() =>
  import('@/pages/AdsPerformancePage').then((m) => ({ default: m.AdsPerformancePage }))
)
export const AdsSettingsPage = lazy(() =>
  import('@/pages/AdsSettingsPage').then((m) => ({ default: m.AdsSettingsPage }))
)
export const AnalyticsPage = lazy(() =>
  import('@/pages/analytics/AnalyticsPage').then((m) => ({ default: m.AnalyticsPage }))
)
export const AttributionLinksPage = lazy(() =>
  import('@/pages/AttributionLinksPage').then((m) => ({ default: m.AttributionLinksPage }))
)
export const AuthAcceptPage = lazy(() =>
  import('@/pages/AuthAcceptPage').then((m) => ({ default: m.AuthAcceptPage }))
)
export const BillingCancelPage = lazy(() =>
  import('@/pages/BillingCancelPage').then((m) => ({ default: m.BillingCancelPage }))
)
export const BillingSuccessPage = lazy(() =>
  import('@/pages/BillingSuccessPage').then((m) => ({ default: m.BillingSuccessPage }))
)
export const BookingsCalendarPage = lazy(() =>
  import('@/pages/BookingsCalendarPage').then((m) => ({ default: m.BookingsCalendarPage }))
)
export const CampaignDetailPage = lazy(() =>
  import('@/pages/CampaignDetailPage').then((m) => ({ default: m.CampaignDetailPage }))
)
export const CampaignEditorPage = lazy(() =>
  import('@/pages/CampaignEditorPage').then((m) => ({ default: m.CampaignEditorPage }))
)
export const CampaignsListPage = lazy(() =>
  import('@/pages/CampaignsListPage').then((m) => ({ default: m.CampaignsListPage }))
)
export const CampaignsPage = lazy(() =>
  import('@/pages/CampaignsPage').then((m) => ({ default: m.CampaignsPage }))
)
export const ChatPage = lazy(() =>
  import('@/pages/ChatPage').then((m) => ({ default: m.ChatPage }))
)
export const ContactsPage = lazy(() =>
  import('@/pages/ContactsPage').then((m) => ({ default: m.ContactsPage }))
)
export const ContentCalendarPage = lazy(() =>
  import('@/pages/ContentCalendarPage').then((m) => ({ default: m.ContentCalendarPage }))
)
export const ContentPage = lazy(() =>
  import('@/pages/ContentPage').then((m) => ({ default: m.ContentPage }))
)
export const CourseOverviewPage = lazy(() =>
  import('@/pages/CourseOverviewPage').then((m) => ({ default: m.CourseOverviewPage }))
)
export const CoursesPage = lazy(() =>
  import('@/pages/CoursesPage').then((m) => ({ default: m.CoursesPage }))
)
export const PromptLibraryPage = lazy(() =>
  import('@/pages/PromptLibraryPage').then((m) => ({ default: m.PromptLibraryPage }))
)
export const InboxPage = lazy(() =>
  import('@/pages/InboxPage').then((m) => ({ default: m.InboxPage }))
)
export const DashboardPage = lazy(() =>
  import('@/pages/DashboardPage').then((m) => ({ default: m.DashboardPage }))
)
export const AgentRoleChatPage = lazy(() =>
  import('@/pages/AgentRoleChatPage').then((m) => ({ default: m.AgentRoleChatPage }))
)
export const AcceptInvitePage = lazy(() =>
  import('@/pages/AcceptInvitePage').then((m) => ({ default: m.AcceptInvitePage }))
)
export const ForgotPasswordPage = lazy(() =>
  import('@/pages/ForgotPasswordPage').then((m) => ({ default: m.ForgotPasswordPage }))
)
export const GmbInsightsPage = lazy(() =>
  import('@/pages/GmbInsightsPage').then((m) => ({ default: m.GmbInsightsPage }))
)
export const GmbPostsPage = lazy(() =>
  import('@/pages/GmbPostsPage').then((m) => ({ default: m.GmbPostsPage }))
)
export const LeadDetailPage = lazy(() =>
  import('@/pages/LeadDetailPage').then((m) => ({ default: m.LeadDetailPage }))
)
export const LeadTriagePage = lazy(() =>
  import('@/pages/LeadTriagePage').then((m) => ({ default: m.LeadTriagePage }))
)
export const LeadsListPage = lazy(() =>
  import('@/pages/LeadsListPage').then((m) => ({ default: m.LeadsListPage }))
)
export const LessonPage = lazy(() =>
  import('@/pages/LessonPage').then((m) => ({ default: m.LessonPage }))
)
export const LibraryPage = lazy(() =>
  import('@/pages/LibraryPage').then((m) => ({ default: m.LibraryPage }))
)
export const LoginPage = lazy(() =>
  import('@/pages/LoginPage').then((m) => ({ default: m.LoginPage }))
)
export const MfaVerifyPage = lazy(() =>
  import('@/pages/MfaVerifyPage').then((m) => ({ default: m.MfaVerifyPage }))
)
export const PreviewPage = lazy(() =>
  import('@/pages/PreviewPage').then((m) => ({ default: m.PreviewPage }))
)
export const OfferPage = lazy(() =>
  import('@/pages/OfferPage').then((m) => ({ default: m.OfferPage }))
)
export const UploadLinkPage = lazy(() =>
  import('@/pages/UploadLinkPage').then((m) => ({ default: m.UploadLinkPage }))
)
export const StatusPage = lazy(() =>
  import('@/pages/StatusPage').then((m) => ({ default: m.StatusPage }))
)
export const SettingsLayout = lazy(() =>
  import('@/pages/settings/SettingsLayout').then((m) => ({ default: m.SettingsLayout }))
)
export const SettingsIndex = lazy(() =>
  import('@/pages/settings/SettingsLayout').then((m) => ({ default: m.SettingsIndex }))
)
export const BusinessPage = lazy(() =>
  import('@/pages/settings/BusinessPage').then((m) => ({ default: m.BusinessPage }))
)
export const AccountsPage = lazy(() =>
  import('@/pages/settings/AccountsPage').then((m) => ({ default: m.AccountsPage }))
)
export const TeamPage = lazy(() =>
  import('@/pages/settings/TeamPage').then((m) => ({ default: m.TeamPage }))
)
export const PlanPage = lazy(() =>
  import('@/pages/settings/PlanPage').then((m) => ({ default: m.PlanPage }))
)
export const ProfilePage = lazy(() =>
  import('@/pages/settings/ProfilePage').then((m) => ({ default: m.ProfilePage }))
)
export const AdvancedPage = lazy(() =>
  import('@/pages/settings/AdvancedPage').then((m) => ({ default: m.AdvancedPage }))
)
export const VoiceClonePage = lazy(() =>
  import('@/pages/VoiceClonePage').then((m) => ({ default: m.VoiceClonePage }))
)
export const FilesPage = lazy(() =>
  import('@/pages/FilesPage').then((m) => ({ default: m.FilesPage }))
)
export const ReviewPage = lazy(() =>
  import('@/pages/ReviewPage').then((m) => ({ default: m.ReviewPage }))
)
export const ApprovalsPage = lazy(() =>
  import('@/pages/ApprovalsPage').then((m) => ({ default: m.ApprovalsPage }))
)
export const NotificationsPage = lazy(() =>
  import('@/pages/NotificationsPage').then((m) => ({ default: m.NotificationsPage }))
)
export const OAuthCallbackPage = lazy(() =>
  import('@/pages/OAuthCallbackPage').then((m) => ({ default: m.OAuthCallbackPage }))
)
export const OAuthConsentPage = lazy(() =>
  import('@/pages/OAuthConsentPage').then((m) => ({ default: m.OAuthConsentPage }))
)
export const OnboardingPage = lazy(() =>
  import('@/pages/OnboardingPage').then((m) => ({ default: m.OnboardingPage }))
)
export const ShopifyInstallPage = lazy(() =>
  import('@/pages/connections/ShopifyInstallPage').then((m) => ({
    default: m.ShopifyInstallPage,
  }))
)
export const RegisterPage = lazy(() =>
  import('@/pages/RegisterPage').then((m) => ({ default: m.RegisterPage }))
)
export const ResetPasswordPage = lazy(() =>
  import('@/pages/ResetPasswordPage').then((m) => ({ default: m.ResetPasswordPage }))
)
export const SmsCampaignComposePage = lazy(() =>
  import('@/pages/SmsCampaignComposePage').then((m) => ({ default: m.SmsCampaignComposePage }))
)
export const MediaLibraryPage = lazy(() =>
  import('@/pages/MediaLibraryPage').then((m) => ({ default: m.MediaLibraryPage }))
)
export const VerifyEmailPage = lazy(() =>
  import('@/pages/VerifyEmailPage').then((m) => ({ default: m.VerifyEmailPage }))
)
export const ShopifyPage = lazy(() =>
  import('@/pages/ShopifyPage').then((m) => ({ default: m.ShopifyPage }))
)
export const ShopifyInsightsPage = lazy(() =>
  import('@/pages/ShopifyInsightsPage').then((m) => ({ default: m.ShopifyInsightsPage }))
)
export const VideoEditorPage = lazy(() =>
  import('@/pages/VideoEditorPage').then((m) => ({ default: m.VideoEditorPage }))
)
export const ImageEditorPage = lazy(() =>
  import('@/pages/ImageEditorPage').then((m) => ({ default: m.ImageEditorPage }))
)
